import { TypedAnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { ClickTrackingInfo } from "@omni/types/components/tracking/tracking-info/click/click.trackingInfo";

import { GoogleAnalyticsEvents } from "../GoogleAnalyticsEvents";
import {
    GoogleAnalyticsBannerImpression,
    getGoogleAnalyticsBannerImpression
} from "./GoogleAnalyticsBannerImpression";

export interface GoogleAnalyticsBannerClick
    extends GoogleAnalyticsBannerImpression {}

const getGoogleAnalyticsBannerClick = (
    data: TypedAnalyticsEvent<ClickTrackingInfo>
): GoogleAnalyticsBannerClick => {
    return getGoogleAnalyticsBannerImpression(
        data,
        GoogleAnalyticsEvents.BannerClick
    );
};

export { getGoogleAnalyticsBannerClick };
